import queryClient from '@/services/queryClient'

const useHandleAIUpdatedSocketMessage = () => {
  const updateImageHandler = ({ fileId, data }) => {
    const { imageUrl, message, status } = data || {}

    queryClient.setQueryData(['get-ai-images-status', fileId], (old) => ({
      ...old,
      images: {
        ...(old?.images || {}),
        [imageUrl]: {
          ...(old?.images?.[imageUrl] || {}),
          status: status,
          message: message,
        },
      },
    }))
  }

  const refetchAIImagesStatusHandler = ({ fileId }) => {
    queryClient.invalidateQueries({
      queryKey: ['get-ai-images-status', fileId],
    })
  }

  return {
    updateImageHandler,
    refetchAIImagesStatusHandler,
  }
}

export default useHandleAIUpdatedSocketMessage
